import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from 'react-redux';
import { useTheme, ThemeProvider, Container, Typography, useMediaQuery, Box, TextField } from "@mui/material";

import { Form, Input, Button, message, Select } from "antd";
import { useNavigate, useParams } from "react-router-dom";


import Dragger from "antd/es/upload/Dragger";
import { UploadOutlined } from "@ant-design/icons";
import useSelection from "antd/es/table/hooks/useSelection";


import SearchIcon from "@mui/icons-material/Search";
import Sidebars from "../../Components/Sidebar/sidebar";
import '../../css/vehicles.css';
import SearchBar from "../../Components/SearchBar";
import { BorderBottom } from "@mui/icons-material";
import appColors from "../../config/appColors";
import { postRequest } from "../../Api";
import { apiRoutes } from "../../Api/apiRoutes";
import { setLoader } from "../../Redux/Reducers/gernalSlice";
import VehicleView from "../../Components/VehicleView";
import { selectStyle } from "../../css/styles";
import RichTextEditor from "../../Components/RichTextEditor";
const { Option } = Select;


const AddAgreementNote = () => {


    const ids = useParams();
    const theme = useTheme();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const user = useSelector((state) => state.authReducer.user);




    const saveNote = async (value) => {

        const onSuccess = () => {
            dispatch(setLoader(false));
            message.success('Note saved!');
            navigate(`/agreement-notes/${ids.id}`);
        }
        const onError = (err) => {
            dispatch(setLoader(false));
            message.error('Failed to save note');
            console.log('err', err)
        }
        const body = {
            token: user?.token,
            agreement_id: ids.id,
            note: JSON.stringify(value),
        }
        console.log('body', body)
        if (!body.note) return message.error('Please add note');
        dispatch(setLoader(true));
        await postRequest(body, apiRoutes.addAgreementNote, onSuccess, onError);


    }


    return (
        <>
            <ThemeProvider theme={theme}>
                <div style={{ display: 'flex', }}>
                    <Sidebars />

                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 20, width: "75%" }} >
                        <span className={`headertext ${isSmallScreen ? 'small-screen' : ''}`}>
                            Add agreement note
                        </span>

                        <div style={{ display: 'flex', flexDirection: 'column', width: "100%", borderRadius: 10, backgroundColor: appColors.white, marginTop: 10, paddingBottom: 10 }}>
                            <div style={{ width: "100%", height: 45, borderTopRightRadius: 10, borderTopLeftRadius: 10, backgroundColor: appColors.primary, display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                <Typography style={{ color: appColors.white, fontSize: 16, fontWeight: 600, marginLeft: 10, marginTop: 10 }}>Note</Typography>
                                {/* {
                                        selectedClient?._id && (
                                            <div style={{ marginRight: 10, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                {
                                                    editCustomer && (
                                                        <div
                                                            onClick={() => setEditCustomer(false)}
                                                            style={{ cursor: 'pointer', marginRight: 20 }}
                                                        >
                                                            <Typography style={{ color: appColors.secondary, fontFamily: 'Poppins' }}>Cancel</Typography>
                                                        </div>
                                                    )
                                                }
                                                <div
                                                    onClick={() => {
                                                        editCustomer ? updateCustomer() : setEditCustomer(true)
                                                    }}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <Typography style={{ color: editCustomer ? '#52FF33' : appColors.white, fontFamily: 'Poppins' }}>{editCustomer ? 'Save' : 'Edit'}</Typography>
                                                </div>

                                            </div>
                                        )
                                    } */}

                            </div>
                            <RichTextEditor
                                onSave={(value) => saveNote(value)}
                            />
                        </div>
                    </div>

                </div>
            </ThemeProvider>
        </>
    )

}



const labelStyle = { color: appColors.black, fontSize: 14, fontFamily: 'Poppins', marginTop: 0 }

export default AddAgreementNote
